'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NONE } from 'DesignData/enums/settings/Categories';
import UIToggle from 'UIComponents/input/UIToggle';
import Accordion from 'DesignManagerIde/components/settings/inputs/Accordion';
import InputWrapper from 'DesignManagerIde/components/settings/inputs/InputWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';

const i18nKey = field => `designManager.settings.categories.${NONE}.${field}`;

export default class General extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onToggleUpdatePreviewer = e => {
      const {
        checked
      } = e.target;
      this.props.setUpdatePreviewer(checked);
    };
  }

  componentDidMount() {
    this.props.registerToolbarContent();
  }

  render() {
    const startupAccordionTitle = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('groups.startup.title')
    });

    const finderInputLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('fields.alwaysShowFinderOnStartup.label')
    });

    const finderInputHelp = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('fields.alwaysShowFinderOnStartup.help')
    });

    const previewerInputLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('fields.updatePreviewer.label')
    });

    const previewerInputHelp = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('fields.updatePreviewer.help')
    });

    return /*#__PURE__*/_jsx("div", {
      className: "settings-editor settings-general-editor",
      children: /*#__PURE__*/_jsxs(Accordion, {
        title: startupAccordionTitle,
        children: [/*#__PURE__*/_jsx(InputWrapper, {
          label: finderInputLabel,
          description: finderInputHelp,
          children: /*#__PURE__*/_jsx(UIToggle, {
            onChange: ({
              target: {
                checked
              }
            }) => {
              this.props.setAlwaysShowFinderOnStartup(checked);
            },
            size: "extra-small",
            checked: this.props.alwaysShowFinderOnStartup
          })
        }), /*#__PURE__*/_jsx(InputWrapper, {
          label: previewerInputLabel,
          description: previewerInputHelp,
          children: /*#__PURE__*/_jsx(UIToggle, {
            onChange: this.onToggleUpdatePreviewer,
            size: "extra-small",
            checked: this.props.updatePreviewer
          })
        })]
      })
    });
  }

}
General.propTypes = {
  alwaysShowFinderOnStartup: PropTypes.bool.isRequired,
  setAlwaysShowFinderOnStartup: PropTypes.func.isRequired,
  updatePreviewer: PropTypes.bool.isRequired,
  setUpdatePreviewer: PropTypes.func.isRequired,
  registerToolbarContent: PropTypes.func.isRequired
};